import * as React from "react";
const SvgInfoFill = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 17,
	height: 17,
	viewBox: "0 0 17 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M8.40002 0.399994C3.98402 0.399994 0.400024 3.98399 0.400024 8.39999C0.400024 12.816 3.98402 16.4 8.40002 16.4C12.816 16.4 16.4 12.816 16.4 8.39999C16.4 3.98399 12.816 0.399994 8.40002 0.399994ZM9.20002 12.4H7.60002V10.8H9.20002V12.4ZM9.20002 9.19999H7.60002V4.39999H9.20002V9.19999Z",
	fill: "black"
}));
export default SvgInfoFill;
